import store from '..';
import {
    AddFactorGroup,
    DeleteFactor,
    MarkDocument,
    QueryCompelete,
    QueryFactorByGroup,
    QueryFactorById,
    QueryFactorGorup,
    QueryFactorPage,
    QueryPerformaceColumns,
    QueryPerformanceSale,
    QuerySaleConfig,
    QuerySaleScore,
    SaveFactor,
    UpdateFactor,
    UpdateFactorGroup,
    UpdateUserGroup,
    deleteGroup,
    linkFactor,
    queryUserGroup,
    removeFactor,
    returnScore,
    returnUserScore,
    updateFactor
} from '../../request/performance';
export default {
    namespace: true,
    state: {
        factorPage: [],
        userGroup: []
    },

    mutations: {
        SET_FACTOR_PAGE(state, factorPage) {
            state.factorPage = factorPage;
        },

        SET_USER_GROUP(state, userGroup) {
            state.userGroup = userGroup;
        }
    },

    actions: {
        QUERY_FACTOR_PAGE: async ({ commit }, payload) => {
            let res = await QueryFactorPage(payload);
            if (res?.code == 200) {
                commit('SET_FACTOR_PAGE', res?.data ?? []);
            }
            return res;
        },

        SAVE_FACTOR: async ({}, payload) => {
            let res = await SaveFactor(payload);
            return res;
        },

        UPDATE_FACTOR_SELF: async ({}, payload) => {
            let res = await UpdateFactor(payload);
            return res;
        },

        DELETE_FACTOR: async ({}, payload) => {
            let res = await DeleteFactor(payload);
            return res;
        },

        QUERY_FACTOR_List: async ({ commit }, payload) => {
            let res = await QueryFactorPage(payload);
            return res;
        },

        QUERY_FACTOR_GROUP: async ({ commit }, payload) => {
            let res = await QueryFactorGorup(payload);
            return res;
        },

        QUERY_FACTOR_BY_GROUP: async ({ commit }, payload) => {
            let res = await QueryFactorByGroup(payload);
            return res;
        },

        ADD_FACTOR_GROUP: async ({ commit }, payload) => {
            let res = await AddFactorGroup(payload);
            return res;
        },

        UPDATE_FACTOR_GROUP: async ({ commit }, payload) => {
            let res = await UpdateFactorGroup(payload);
            return res;
        },

        LINK_FACTOR: async ({ commit }, payload) => {
            let res = await linkFactor(payload);
            return res;
        },

        REMOVE_FACTOR: async ({ commit }, payload) => {
            let res = await removeFactor(payload);
            return res;
        },
        UPDATE_FACTOR: async ({ commit }, payload) => {
            let res = await updateFactor(payload);
            return res;
        },

        QUERY_USER_GROUP: async ({ commit }, payload) => {
            let res = await queryUserGroup(payload);
            if (res?.code == 200) {
                commit('SET_USER_GROUP', res.data ?? []);
            }
            return res;
        },

        UPDATE_USER_GROUP: async ({ commit }, payload) => {
            let res = await UpdateUserGroup(payload);
            return res;
        },

        DELETE_GROUP: async ({ commit }, payload) => {
            let res = await deleteGroup(payload);
            return res;
        },

        QUERY_RETURN_SCORE: async ({ commit }, payload) => {
            let res = await returnScore(payload);
            return res;
        },

        QUERY_RETURN_USER_SCORE: async ({ commit }, payload) => {
            let res = await returnUserScore(payload);
            return res;
        },

        QUERY_COMPELETE: async ({ commit }, payload) => {
            let res = await QueryCompelete(payload);
            return res;
        },

        QUERY_SALE_SCORE: async ({ commit }, payload) => {
            let res = await QuerySaleScore(payload);
            return res;
        },

        QUERY_SALE_CONFIG: async ({ commit }, payload) => {
            let res = await QuerySaleConfig(payload);
            return res;
        },

        MARK_DOCUMENT: async ({}, payload) => {
            let res = await MarkDocument(payload);
            return res;
        },

        QUERY_PERFORMACE_SALE: async ({}, payload) => {
            let res = await QueryPerformanceSale(payload);
            return res;
        },

        QUERY_PERFORMACE_COLUMNS: async ({}, payload) => {
            let res = await QueryPerformaceColumns(payload);
            return res;
        },

        QUERY_FACTOR_BY_GROUPID: async ({}, payload) => {
            let res = await QueryFactorById(payload);
            return res;
        }
    }
};
